import WeakMap from './_WeakMap.js';

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

export default metaMap;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_metaMap.js
// module id = 771
// module chunks = 0